<template>
  <v-dialog v-model="show" max-width="550px" persistent>
    <v-card>
      <v-alert prominent class="mb-0 pa-6">
        <div class="d-flex">
          <v-icon left large>warning</v-icon>
          <div>
            {{ deleteFieldAlertMessage }}
            <!-- 紐付き先の一覧 (紐付きがある場合は削除をブロックする) -->
            <div v-if="blocked" class="mt-2">
              <div v-if="linkedTaskCount > 0" class="subtitle-2">
                {{ $tt('feed.fieldDeleteLinkedTasks', { count: linkedTaskCount }) }}
              </div>
              <div v-if="linkedSets.length" class="subtitle-2">
                {{ $tt('feed.fieldDeleteLinkedSets', { names: linkedSets.map(s => s.name).join(', ') }) }}
              </div>
              <div class="caption mt-2">{{ $tt('feed.fieldDeleteLinkedHint') }}</div>
            </div>
          </div>
        </div>
      </v-alert>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="secondary" @click="show = false">
          {{ $tt('customCancel') }}
        </v-btn>
        <v-btn v-if="!blocked" color="primary" @click="executeDeleteField()">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
    <now-loading-overlay-component :nowLoading="nowLoading" />
  </v-dialog>
</template>

<script>
import i18n from '@/lib/i18n'
import feedApiClient from '@/lib/feed-api-client'
import NowLoadingOverlayComponent from '@/components/NowLoadingOverlayComponent'

export default {
  name: 'FieldDeleteDialogComponent',
  components: {
    NowLoadingOverlayComponent,
  },
  data() {
    return {
      show: false,
      fieldForDelete: undefined,
      deleteFieldAlertMessage: null,
      nowLoading: false,
      blocked: false,
      linkedTaskCount: 0,
      linkedSets: [],
    }
  },

  methods: {
    async openDeleteFieldDialog(field) {
      this.fieldForDelete = field
      this.blocked = false
      this.linkedTaskCount = 0
      this.linkedSets = []
      this.openNowLoading()

      // 圃場セットへの紐付きを確認 (feed-api 不達時はスキップして作業チェックのみで判断)
      try {
        const res = await feedApiClient.fieldSets()
        const sets = res.data.records || []
        const results = await Promise.all(
          sets.map(async s => {
            try {
              const fr = await feedApiClient.fieldSetFields(s.id)
              const members = fr.data.records || []
              return members.some(m => String(m.field_id) === String(field.pk)) ? s : null
            } catch (e) {
              return null
            }
          })
        )
        this.linkedSets = results.filter(Boolean)
      } catch (e) {
        console.error(e.response || e)
      }

      // 作業履歴への紐付き (件数) を確認
      const request = {
        field: this.fieldForDelete,
        onSuccess: this.checkCountTaskForFieldonSuccess,
        onFailure: this.checkCountTaskForFieldOnFailure,
      }
      this.$store.dispatch('checkCountTaskForField', request)
    },
    checkCountTaskForFieldOnFailure() {
      // FIXME 失敗したアラート
      this.closeNowLoading()
    },
    checkCountTaskForFieldonSuccess(response) {
      this.closeNowLoading()
      // 応答は数値または {taskCount: N} の両形式がある
      const data = response.data
      this.linkedTaskCount = (data && data.taskCount) != null ? data.taskCount : Number(data) || 0
      let fieldName = this.fieldForDelete.name
      if (fieldName) {
        fieldName = i18n.tt('customFieldThisFieldName', { fieldName })
      } else {
        fieldName = i18n.tt('customFieldUnknownFieldName')
      }

      // 作業履歴または圃場セットに紐づいている場合は紐付き先を表示して削除させない
      if (this.linkedTaskCount > 0 || this.linkedSets.length > 0) {
        this.blocked = true
        this.deleteFieldAlertMessage = i18n.tt('feed.fieldDeleteLinked', { fieldName })
      } else {
        this.blocked = false
        this.deleteFieldAlertMessage = i18n.tt('customFieldDeleteAlertWithoutTask', { fieldName })
      }
      this.show = true
    },
    closeDeleteFieldDialog() {
      this.show = false
      this.fieldForDelete = null
    },
    executeDeleteField() {
      if (this.fieldForDelete) {
        this.openNowLoading()
        const request = {
          field: this.fieldForDelete,
          onSuccess: this.deleteFieldOnSuccess,
          onFailure: this.deleteFieldOnFailure,
        }
        this.$store.dispatch('deleteField', request)
        this.closeDeleteFieldDialog()
      }
    },
    deleteFieldOnSuccess() {
      this.closeNowLoading()
      this.closeDeleteFieldDialog()
      this.$store.dispatch('initFields2')
    },
    deleteFieldOnFailure() {
      // FIXME 失敗したアラート
      this.closeNowLoading()
      this.closeDeleteFieldDialog()
    },
    openNowLoading() {
      this.nowLoading = true
    },
    closeNowLoading() {
      this.nowLoading = false
    },
  },
}
</script>

<style scoped></style>
